// extracted by mini-css-extract-plugin
export default {"logo":"GobpXM9ABbrWdDBeKA4J","header":"RJizYGaO6nXY8IV7B6cg","container":"yaJQN3Y0cwsIxPtpfQ1K"};